import { mapIntegrationConflictsSummaryFromDTO } from '@/modules/common/mappers/integration-conflicts.mapper';
import { IntegrationConflictsSummaryResponse } from '@/modules/common/types/dto/response/integration-conflicts-response';
import { IntegrationConflictsSummary } from '@/modules/common/types/integration-conflicts';
import { axiosInstance } from '@/utils/axios';

import { ApiErrorCode, withApiErrorHandler } from './errors';

/**
 * Fetches whether the organization has unresolved data conflicts
 * and the super admins who can resolve them.
 */
export const getIntegrationConflicts = async (): Promise<IntegrationConflictsSummary> => {
  const endpoint = '/api/integrations/conflicts';

  const response = await withApiErrorHandler<IntegrationConflictsSummaryResponse>(
    endpoint,
    ApiErrorCode.INTEGRATION_CONFLICTS_LOAD_FAILED,
    () => axiosInstance.get(endpoint)
  );

  return mapIntegrationConflictsSummaryFromDTO(response);
};
